import React from "react";
import SectionHeading from "../common/SectionHeading";
import { contactContent, contactDetails } from "../../data/site";
import "./Contact.css";

/**
 * Closing contact section.
 *
 * The previous site had no contact section at all — the header's "Kontakt"
 * link scrolled to the footer. Here the e-mail address is the largest piece
 * of type on the page below the hero, because sending one is the single action
 * the site exists to produce.
 *
 * @returns {JSX.Element}
 */
function Contact() {
  return (
    <section className="contact section" id="kontakt">
      <div className="shell">
        <SectionHeading
          index={contactContent.index}
          eyebrow={contactContent.eyebrow}
          headlineLines={[contactContent.headline]}
          headlineClassName="t-headline contact__headline"
        />

        <div className="contact__grid">
          <div className="contact__primary">
            <p className="t-lead contact__lead" data-reveal="rise-sm">
              {contactContent.lead}
            </p>

            <a
              className="contact__email"
              href={`mailto:${contactDetails.emailAddress}`}
              data-reveal="rise-sm"
            >
              <span className="contact__email-text">
                {contactDetails.emailAddress}
              </span>
              <span className="contact__email-rule" aria-hidden="true" />
            </a>
          </div>

          <dl className="contact__details" data-reveal="rise-sm">
            <div className="contact__detail">
              <dt className="t-label">Telefon</dt>
              <dd>
                <a
                  className="contact__detail-link"
                  href={`tel:${contactDetails.telephoneHref}`}
                >
                  {contactDetails.telephoneDisplay}
                </a>
              </dd>
            </div>

            <div className="contact__detail">
              <dt className="t-label">Adresa</dt>
              <dd>
                <a
                  className="contact__detail-link"
                  href={contactDetails.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contactDetails.streetAddress}
                  <br />
                  {contactDetails.postalCode} {contactDetails.city}
                  <br />
                  {contactDetails.country}
                  <span className="contact__detail-arrow" aria-hidden="true">
                    ↗
                  </span>
                  <span className="visually-hidden">
                    (otvara se u novom prozoru)
                  </span>
                </a>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}

export default Contact;
